import { injectable, inject } from 'inversify';
import { TYPES } from '@/di/tokens';
import { 
  IMercadoPagoRepository,
  CreateMpPreferenceRequest,
  CreateMpPreferenceResponse
} from '@/domain/repositories/IMercadoPagoRepository';

/**
 * Action para crear una preferencia de pago en Mercado Pago
 */
@injectable()
export class CreateMpPreferenceAction {
  constructor(
    @inject(TYPES.IMercadoPagoRepository) private mercadoPagoRepository: IMercadoPagoRepository
  ) {}

  async execute(request: CreateMpPreferenceRequest): Promise<CreateMpPreferenceResponse> {
    // Validaciones
    if (!request.title || request.title.trim().length === 0) {
      throw new Error('El título del pago no puede estar vacío');
    }

    if (!request.externalReference || request.externalReference.trim().length === 0) {
      throw new Error('La referencia externa no puede estar vacía');
    }

    if (request.unitPrice <= 0) {
      throw new Error('El precio debe ser mayor a cero');
    }

    if (request.quantity <= 0) {
      throw new Error('La cantidad debe ser mayor a cero');
    }

    // Crear preferencia de pago
    return await this.mercadoPagoRepository.createPreference(request);
  }
}
